import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
} from "@chakra-ui/react";
import { useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

interface ModalConfirmCancelLoteProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onConfirm: () => void;
  batchId: string;
}

export default function ModalConfirmCancelLote({
  isOpen,
  setIsOpen,
  onConfirm,
  batchId,
}: ModalConfirmCancelLoteProps) {
  const [colors] = useRecoilState(customColors);

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirmar Cancelamento do Lote</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Tem certeza de que deseja cancelar o lote com ID {batchId}? Esta
            ação não pode ser desfeita.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="outline"
            colorScheme="gray"
            mr={3}
            onClick={() => setIsOpen(false)}
          >
            Cancelar
          </Button>
          <Button
            bgColor={colors.REDMONEDD}
            color={colors.WHITE}
            onClick={() => {
              onConfirm();
              setIsOpen(false);
            }}
            _hover={{ bgColor: colors.REDCARD }}
          >
            Confirmar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
